import React from "react";
import { NavBar as DSNav } from "widgets/NavBar";
import { PatientAppBillingMenuContext } from "./interfaces";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

export const BillingMenu = ({
    allBillsUrl,
    statementHistoryUrl,
    paymentHistoryUrl,
}: PatientAppBillingMenuContext) => {
    return (
        <DSNav.Menu>
            <DSNav.MenuButton
                onClick={() =>
                    recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.BILLING_DROPDOWN_BTN)
                }
            >
                {gettext("Billing")}
            </DSNav.MenuButton>
            <DSNav.MenuItems>
                {allBillsUrl && (
                    <DSNav.MenuItem
                        href={allBillsUrl}
                        onClick={() =>
                            recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.ALL_BILLS_BTN)
                        }
                    >
                        {gettext("All bills")}
                    </DSNav.MenuItem>
                )}
                {statementHistoryUrl && (
                    <DSNav.MenuItem
                        href={statementHistoryUrl}
                        onClick={() =>
                            recordPatientAppClickEngagement(
                                NAV_MENU_V3_ENGAGEMENTS.STATEMENT_HISTORY_BTN,
                            )
                        }
                    >
                        {gettext("Statement history")}
                    </DSNav.MenuItem>
                )}
                {paymentHistoryUrl && (
                    <DSNav.MenuItem
                        href={paymentHistoryUrl}
                        onClick={() =>
                            recordPatientAppClickEngagement(
                                NAV_MENU_V3_ENGAGEMENTS.PAYMENT_HISTORY_BTN,
                            )
                        }
                    >
                        {gettext("Payment history")}
                    </DSNav.MenuItem>
                )}
            </DSNav.MenuItems>
        </DSNav.Menu>
    );
};
